<div class="modal-header">
  <h4 class="modal-title">{{ 'copyClass.title' | translate }}</h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="class-info mb-5">
    <div class="fw-semibold text-gray-600 fs-7">{{ 'copyClass.copying' | translate }}:</div>
    <div class="fw-bold fs-5">{{ eventClass.class_name }}</div>
  </div>

  @if (error) {
    <div class="alert alert-danger mb-5">{{ error }}</div>
  }

  <div class="fw-semibold text-gray-600 mb-3">{{ 'copyClass.selectTargetDays' | translate }}:</div>

  @if (eventDays.length === 0) {
    <div class="text-center text-muted py-5">
      <i class="fa fa-calendar-xmark fs-3x mb-3 d-block opacity-50"></i>
      <p>{{ 'copyClass.noOtherDays' | translate }}</p>
    </div>
  } @else {
    <div class="day-grid">
      @for (day of eventDays; track day.date.getTime()) {
        <div class="day-option"
             [class.selected]="isDaySelected(day)"
             (click)="toggleDay(day)">
          <div class="day-checkbox">
            @if (isDaySelected(day)) {
              <i class="fa fa-check"></i>
            }
          </div>
          <div class="day-info">
            <div class="day-label">{{ day.label }}</div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">{{ 'common.cancel' | translate }}</button>
  <button type="button"
          class="btn btn-primary"
          [disabled]="copying || selectedDays.length === 0"
          (click)="copyClass()">
    @if (copying) {
      <span class="spinner-border spinner-border-sm me-2"></span>
      {{ 'copyClass.copying' | translate }}...
    } @else {
      <i class="fa fa-copy me-2"></i>
      {{ 'copyClass.copy' | translate }}
    }
  </button>
</div>
